//#region Imports
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import tickicon from "../../../images/Accept.png";
import pdfIcon from '../../../images/pdfIcon.png';
import crossIcon from "../../../images/remove.png";
//components
import Base64Image from '../../../components/Base64Image/Base64Image';
import Error from '../../../components/error/error';
//scss
// import "./InstallmentsTable.scss"
import "../../../style/common.scss";
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import { useDispatch, useSelector } from 'react-redux';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import BasicTable from '../../../components/basicTable/basicTable';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';
import {
    fetchPaginatedSetAsideNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal
} from '../../../features/billingAndCollection/setAsideNormalSlice';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { convertToObjectArray, dBillAPI, downloadBill, getDocumentBackGroundColor, subdivisionName } from '../../../services/Functions';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import { tableStyle, tableStyleOverDue } from '../../../style/common';

import {
    fetchPaginatedSetAsideOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue
} from '../../../features/billingAndCollection/setAsideOverdueSlice';

//#endregion

const SetAsideTable = forwardRef((props, ref) => {

    //#region initial values
    const initialValues = {
        iv_objection_remarks: ''
    }

    //#endregion

    //#region get item local storage 
    const { token, userId, code: officeCode, hierarchy: officeHierarchy, permissions } = useSelector((state) => state.auth)
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const dispatch = useDispatch();
    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal } = useSelector((state) => state.setAsideNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue } = useSelector((state) => state.setAsideOverduePaginated);

    const handleNextPage = () => {
        setViewBackdrop(true)
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        setViewBackdrop(true)
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = () => {
        dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
    };

    useEffect(() => {
        if (token) {
            setViewBackdrop(true)
            dispatch(fetchPaginatedSetAsideNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal]);

    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedSetAsideNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    }, []);

    useEffect(() => {
        if (dataNormal) {
            setSetAsideApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal])

    const handleNextPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = () => {
        dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
    };

    useEffect(() => {
        if (token) {
            setViewBackdrop(true)
            dispatch(fetchPaginatedSetAsideOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue]);

    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedSetAsideOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
    }, []);

    useEffect(() => {
        if (dataOverdue) {
            setSetAsideApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue])

    //#endregion

    //#region states 
    const [setAsideApplicationsNormal, setSetAsideApplicationsNormal] = useState([]);
    const [setAsideApplicationsNormalToDataGrid, setSetAsideApplicationsNormalToDataGrid] = useState([]);
    const [setAsideApplicationsOverdue, setSetAsideApplicationsOverdue] = useState([]);
    const [setAsideApplicationsOverdueToDataGrid, setSetAsideApplicationsOverdueToDataGrid] = useState([]);
    const [installmentsArray, setInstallmentsArray] = useState([])
    const [open, setOpen] = React.useState(false);
    const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [billHistInfo, setBillHistInfo] = useState([]);
    const [currentBill, setCurrentBill] = useState(false);
    const [billMonth, setBillMonth] = useState(false);
    const [arrears, setArrears] = useState(false);
    const [orderImage, setApplicantCNIC] = useState();
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [ApplicationsubmittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [copyOfApplicantCNICVerifyPopUp, setcopyOfApplicantCNICVerifyPopUp] = useState(false)
    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setcopyOfApplicantCNICVerifyPopUp(x);
    }
    const [maxBillAmount, setMaxBillAmount] = useState(0);
    const [minDownPayment, setMinDownPayment] = useState(0);
    const [error, setError] = useState('')
    const [eFileData, setEFileData] = useState([]);

    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },]

    let NCStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMISSION',
        },
        {
            title1: 'FINAL',
            title2: 'ACTION',
        },
    ]
    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])

    const [foundInInstallments, setFoundInInstallments] = useState();
    const [flag_courtOrderImg, setFlag_courtOrderImage] = useState(null);
    const [courtOrderDocVerifyPopUp, setCourtOrderDocVerifyPopUp] = useState(false);
    const [courtOrderImgObjectionRemarks, setCourtOrderImageObjectionRemarks] = useState('');

    const { state } = useLocation();
    const { foundId } = state ? state : '';
    //#endregion

    //#region constants / variables 

    const BillingHistColumns = [{
        header: 'Month',
        accessorKey: 'gbHistMM',
    },
    {
        header: 'Units',
        accessorKey: 'gbHistUnits',
    },
    {
        header: 'Billed',
        accessorKey: 'gbHistAssment',
    },
    {
        header: 'Payment',
        accessorKey: 'payment',
    },
    ]

    const InstallmentsTableColumns = [{
        header: 'Sr.',
        accessorKey: 'serial',
    },
    {
        header: 'Percentage',
        accessorKey: 'percentage',
    },
    {
        header: 'Month',
        accessorKey: 'month',
    }]

    //#endregion

    //#region api function

    const billHistoryFunc = async (refNo) => {
        let apiResponse = await dBillAPI(token, refNo)
        if (apiResponse.status) {
            setArrears(parseInt(apiResponse.basicInfo.arrear))
            setCurrentBill(parseInt(apiResponse.basicInfo.currAmntDue))
            setBillMonth(apiResponse.basicInfo.billMonth.slice(0, 10))
            let HistInfoArray = apiResponse.histInfo
            let convertedArray = convertToObjectArray(HistInfoArray)
            setBillHistInfo(convertedArray)
        } else {
            console.log('Reference No. not found!')
        }
    }

    const installmentsProgressAPI = async (x) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("lastModifiedBy", userId);
        formdata.append("applicationProgressId", x);
        formdata.append("downPayment", 0)
        formdata.append("approvedNoOfMonthsForinstallment", 0)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "installments/installmentAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    handleClose()
                }
            })
            .catch(error => console.log('error', error));
    }

    const callGetSetAsideApplicantCNICDocument = async (applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "CourtOrder/getCODocuments", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    setApplicantCNIC(result.images[0].courtOrderImg)
                }
                else {
                    // console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }

    const callEfileAPI = async (application) => {

        var formdata = new FormData();
        formdata.append("applicationId", application.applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "installments/getInstallmentHistory", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let applicationCurrentState = result.applicationCurrentState[0]
                    let applicationHistory = result.applicationHistory
                    if (applicationHistory === "No History Found") {
                        applicationHistory = []
                    }

                    applicationHistory.push(applicationCurrentState)
                    let sortedApplicationHistory = applicationHistory.sort((a, b) => {
                        const dateA = new Date(a.lastModificationDate)
                        const dateB = new Date(b.lastModificationDate)
                        return dateB - dateA
                    });

                    setEFileData(sortedApplicationHistory)

                    let dataforTable = []

                    sortedApplicationHistory.forEach(item => {
                        if (item.applicationProgressId !== 0 && item.lastModifiedBy && item.lastModificationDate) {
                            let object = {}
                            object.stepName = stepName(item.applicationProgressId)
                            object.processedBy = item.lastModifiedBy ? item.lastModifiedBy : 'Last Modified By Name'
                            object.date = item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'Last Modification Time'
                            object.remarks = item.remarks ? item.remarks : '-'
                            dataforTable.push(object)
                        }
                    })

                    dataforTable.push({
                        date: convertDate(application.creationDate),
                        processedBy: application.applicantName,
                        stepName: "Application Submitted",
                        time: convertDatewithTime(application.creationDate).slice(11, 17),
                        remarks: '-'
                    })

                    setTableDataProcessingSummary(dataforTable);
                }
                else {
                    // console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }

    const callChangeProgressIdAPI = async (applicationProgressId, status, remarks, remarksDetails = '-', id = dialogRowData.applicationId) => {
        var formdata = new FormData();

        formdata.append("applicationId", id);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("lastModifiedBy", userId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "CourtOrder/courtOrderAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    handleClose()
                }
                else {
                }
            })
            .catch(error => console.log('error', error));

    }

    const callChangeObjectionStatus = async (objectionStatus, remarks, remarksDetails = '-') => {
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("objectionStatus", objectionStatus);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("lastModifiedBy", userId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    handleClose();
                }
                else {
                }
            })
            .catch(error => console.log('error', error));
        setObjectionPopUpOpen(false)

    }

    //#endregion

    //#region functions

    const getType = (code) => {
        switch (code) {
            case 'C':
                return 'Court';
            case 'D':
                return 'Department';
            default:
                return 'Type'
        }
    }
    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "Application Submitted" || stepName === "APPLICATION SUBMITTED") {
            setApplicationSubmittedPopUp(true)
        }
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                    console.warn('Invalid code format:', code);
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = async () => {
        setDialogRowData({});
        setFoundInInstallments();
        setOpen(false);
        dispatch(fetchPaginatedSetAsideNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }))
        dispatch(fetchPaginatedSetAsideOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
    };

    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterSetAsideApplications = async (applicationId) => {
        let normalArray = setAsideApplicationsNormal
        let totalArray = normalArray.concat(setAsideApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)
        if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '12')
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversionNormal = () => {
        const tempArray = []
        if (setAsideApplicationsNormal) {
            setAsideApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId || item.applicationId === 0) {
                    if (item.objectionStatus === 0 || item.objectionStatus === 2) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.name,
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                        tempArray.push(dataGridObject)
                    } else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.name,
                            "applicationProgressId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                        tempArray.push(dataGridObject)
                    }
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "creationDate": ' ',
                "referenceNo": ' ',
                "applicantName": ' ',
                "noOfInstallments": ' ',
                "billMonthAmount": ' ',
                "applicationProgressId": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setSetAsideApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {
        const tempArray = []
        if (setAsideApplicationsOverdue) {
            setAsideApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(item.billMonthAmount),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(item.billMonthAmount),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "creationDate": ' ',
                "referenceNo": ' ',
                "applicantName": ' ',
                "noOfInstallments": ' ',
                "billMonthAmount": ' ',
                "applicationStatusId": ' ',
                "applicationProgressId": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setSetAsideApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {

        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x == 0) {
            return 'Pending'
        }
        else if (x == 1) {
            return 'Inprocess'
        }
        else if (x == 2) {
            return 'Approved'
        }
    }

    const numberFormatting = (number) => {
        let intNumber = number
        if (intNumber) {

            if (typeof number === 'string') {
                intNumber = parseInt(number)
            }
            let formattedNumber = intNumber.toLocaleString(
                undefined,
                {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }
            )
            return formattedNumber
        }
    };

    const errorCloses = () => {
        setError('')
    };

    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        const item = await filterSetAsideApplications(applicationId);
        setDialogRowData(item);
        // await callGetSetAsideApplicantCNICDocument(item.applicationId)
        setFlag_courtOrderImage(item.courtOrderImgFlag)
        setCourtOrderImageObjectionRemarks(item.courtOrderImgRemarks)
        if (item) {
            var formdata = new FormData();
            formdata.append("applicationId", item.applicationId);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "CourtOrder/getCODocuments", requestOptions)
                .then(response => response.json())
                .then(result => {
                    setDialogRowData(prevObject => ({
                        ...prevObject,
                        "courtOrderImg": result.images[0].courtOrderImg,
                    }));

                })
                .catch(error => console.log('error', error));
        }
        setapllicationid(item.applicationId)
        await callEfileAPI(item);
        setOpen(true);
        setViewBackdrop(false);
    };

    const hideObjectionPopup = () => {
        setAsideVerificationObjectionFormik.resetForm()
        setObjectionPopUpOpen(false);
    };

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submitted'
        }
        else if (x === 1) {
            return 'Action Taken'
        }
    };

    const objectionpop = () => {
        setObjectionPopUpOpen(open)
    }

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const hideCourtOrderDocVerifyAlert = (x) => {
        setCourtOrderDocVerifyPopUp(x)
    }

    const updateDocFlag = (documentName, value, remarks) => {
        switch (documentName) {
            case 'courtOrderImg':
                setFlag_courtOrderImage(value);
                setCourtOrderImageObjectionRemarks(remarks)
                setCourtOrderDocVerifyPopUp(false);
                break
            default:
                break
        }
    }

    const callSetAsideApplicationApproval = async () => {
        try {
            await callChangeProgressIdAPI(1, '', 'Application Approved', 'Application Approved', dialogRowData.applicationId)
        }
        catch (e) {
            console.log('error updating status of set aside application to verified')
        }
    }

    //#endregion

    //#region formiks

    const setAsideVerificationObjectionFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_objection_remarks: Yup.string().required('Enter reason for rejection.').min(10, "Reason should be between 10 to 200 characters!").max(200, "Reason should be between 10 to 200 characters!")
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            callChangeObjectionStatus(1, values.iv_objection_remarks, values.iv_objection_remarks)
            setViewBackdrop(false)
        }
    })

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (setAsideApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [setAsideApplicationsNormal]);

    useEffect(() => {
        if (setAsideApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [setAsideApplicationsOverdue]);

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInInstallments(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInInstallments) {
            handleRowClick(foundInInstallments)
        }
    }, [foundInInstallments])

    useEffect(() => {

    }, [])

    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationProgressId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['Pending', 'In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationProgressId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        // { field: "noOfInstallments", type: 'number', headerName: 'No. of Installments', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        // { field: "billMonthAmount", headerName: 'Bill Amount', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    const location = useLocation()
    const currentPath = location.pathname;

    return (
        <>
            {/* Applications Table */}
            <ServiceDashboardTables
                enabled={currentPath === "/set-aside-table"}
                normalTitle={`Set Aside / Withdrawal ( ${numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
                overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={setAsideApplicationsNormalToDataGrid}
                overdueData={setAsideApplicationsOverdueToDataGrid}
                onRowClick={handleRowClick}
                mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
                normalTableProps={{
                    firstPage: handleFirstPage,
                    lastPage: handleLastPage,
                    totalPages: totalPagesNormal,
                    totalRecords: totalRecordsNormal,
                    currentPage: currentPageNormal,
                    handleFilterDateFrom: handleDateFromFilter,
                    handleFilterDateTo: handleDateToFilter,
                    resetDateFilter: handleResetDateFilter,
                    handleFilterProgressId: handleProgressIdFilter,
                    handleFilterObjectionStatus: handleObjectionStatusFilter,
                    resetProgressIdFilter: handleResetProgressIdFilter,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilter,
                    nextPage: handleNextPage,
                    previousPage: handlePreviousPage,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    handleFilterDateFrom: handleDateFromFilterOverdue,
                    handleFilterDateTo: handleDateToFilterOverdue,
                    resetDateFilter: handleResetDateFilterOverdue,
                    resetProgressIdFilter: handleResetProgressIdFilterOverdue,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
                    handleFilterProgressId: handleProgressIdFilterOverdue,
                    handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
                    totalPages: totalPagesOverdue,
                    totalRecords: totalRecordsOverdue,
                    currentPage: currentPageOverdue,
                }}
            />

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'false'}
                className='main-dialog'
            >
                <DialogTitle className="dialog-title" >
                    <Grid container spacing={1} className='headercontainer'>
                        <Grid item lg={0.5}></Grid>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Set Aside / Withdrawal -
                                <span style={{ color: 'white' }}>
                                    {dialogRowData.applicationProgressId === 0 && ' Final Action'}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item lg={0.25} className="closeIcon" >
                            <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid container spacing={1} className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar array={NCStatusBarArray} applicationProgressId={dialogRowData.applicationProgressId + 1} objection={dialogRowData.objectionStatus} openDetailsPopUp={openDetailsPopUp} pageName='Set Aside' />
                            </Grid>
                            <Grid item lg={12} className='application-details'>
                                <Grid container gap={'4%'} className="first-row">
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'> Application Id.</p>
                                        <p className='prop-detail'> {dialogRowData.applicationId}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'> Reference No.</p>
                                        <p className='prop-detail'> {dialogRowData.refNo ? dialogRowData.refNo : "-"}</p>
                                    </Grid>
                                    <Grid item lg={3.5} className='first-row-item'>
                                        <p className='prop-title'> Address</p>
                                        <p className='prop-detail'> {dialogRowData.address ? dialogRowData.address : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Connection Type </p>
                                        <p className='prop-detail'> {dialogRowData.connectionType ? dialogRowData.connectionType : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Tariff </p>
                                        <p className='prop-detail'> {dialogRowData.tariffDesc ? dialogRowData.tariffDesc : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Subdivision </p>
                                        <p className='prop-detail'> {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Name</p><p className='prop-detail'>{dialogRowData.name ? dialogRowData.name : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant CNIC</p><p className='prop-detail'>{dialogRowData.cnic ? dialogRowData.cnic : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Phone</p><p className='prop-detail'>{dialogRowData.phoneNo ? dialogRowData.phoneNo : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Email</p><p className='prop-detail'>{dialogRowData.email ? dialogRowData.email : "-"}</p>
                                    </Grid>
                                    <Grid item lg={1} className="first-row-item">
                                        <p className='prop-title'>Order Type</p><p className='prop-detail'>{dialogRowData.adjType ? getType(dialogRowData.adjType) : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'>Bill Amount (PKR)</p><p className='prop-detail'>{dialogRowData.BillMonthTotalAmount ? numberFormatting(dialogRowData.BillMonthTotalAmount) : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item' >
                                        <p className='prop-title'>Bill Month</p><p className='prop-detail'>{dialogRowData.BillMonth ? convertDate(dialogRowData.BillMonth.slice(0, 10)).slice(2) : '-'}</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                {
                                    <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                                }
                            </Grid>
                            <Grid item className="action-form">
                                <div className='fields'>
                                    {(dialogRowData.applicationProgressId === 0 || dialogRowData.applicationProgressId === 1) && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                        CheckPermissions(permissions, 'General Services', 'New Connection', 'Workflow Permissions', 'Document Verification') ?
                                            <>
                                                <h3 className='step-title'>{dialogRowData.applicationProgressId === 0 ? 'Final Action' : 'Final Action'}</h3>
                                                <Grid container spacing={2} className='field-survey-container'>
                                                    <Grid item lg={1.5}>
                                                        <Typography className='fieldLabel'>Order No.</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderNo ? dialogRowData.courtOrderNo : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    <Grid item lg={1.5}>
                                                        <Typography className='fieldLabel'>Order Date</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderDate ? convertDate(dialogRowData.courtOrderDate) : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    <Grid item lg={3.5}>
                                                        <Typography className='fieldLabel'>Order Authority</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderBy ? dialogRowData.courtOrderBy : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    <Grid item lg={1.5}>
                                                        <Typography className='fieldLabel'>Set Aside Amount</Typography>
                                                        <TextField
                                                            value={dialogRowData.deferredAmount ? numberFormatting(dialogRowData.deferredAmount) : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    {
                                                        dialogRowData.setAsideOrWithdrawFlag == 1 && <>
                                                            <Grid item lg={2}>
                                                                <Typography className='fieldLabel'>New Set Aside Amount</Typography>
                                                                <TextField
                                                                    value={dialogRowData.setAsideAmount ? numberFormatting(dialogRowData.setAsideAmount) : '-'}
                                                                    fullWidth
                                                                    disabled
                                                                    className='fieldCoverageMarla'
                                                                />
                                                            </Grid>
                                                            <Grid item lg={2}>
                                                                <Typography className='fieldLabel'>Total Set Aside Amount</Typography>
                                                                <input
                                                                    value={numberFormatting((dialogRowData.deferredAmount ? dialogRowData.deferredAmount : 0) + (dialogRowData.setAsideAmount ? dialogRowData.setAsideAmount : 0))}
                                                                    fullWidth
                                                                    disabled
                                                                    className='fieldCoverageMarla'
                                                                    style={{ padding: '7.5px', backgroundColor: '#006ad1', color: 'white', border: 'none', borderRadius: '5px', width: '85%', fontSize: '18px' }}
                                                                />
                                                            </Grid>
                                                        </>
                                                    }
                                                    {
                                                        dialogRowData.setAsideOrWithdrawFlag == 2 && <>
                                                            <Grid item lg={2}>
                                                                <Typography className='fieldLabel'>Withdrawal Amount</Typography>
                                                                <TextField
                                                                    value={dialogRowData.withdrawalSetAsideAmount ? numberFormatting(dialogRowData.withdrawalSetAsideAmount) : '-'}
                                                                    fullWidth
                                                                    disabled
                                                                    className='fieldCoverageMarla'
                                                                />
                                                            </Grid>
                                                            <Grid item lg={2}>
                                                                <Typography className='fieldLabel'>Total Set Aside Amount</Typography>
                                                                <input
                                                                    value={numberFormatting((dialogRowData.deferredAmount ? dialogRowData.deferredAmount : 0) - (dialogRowData.withdrawalSetAsideAmount ? dialogRowData.withdrawalSetAsideAmount : 0)) ? numberFormatting((dialogRowData.deferredAmount ? dialogRowData.deferredAmount : 0) - (dialogRowData.withdrawalSetAsideAmount ? dialogRowData.withdrawalSetAsideAmount : 0)) : 0}
                                                                    fullWidth
                                                                    disabled
                                                                    className='fieldCoverageMarla'
                                                                    style={{ padding: '7.5px', backgroundColor: '#006ad1', color: 'white', border: 'none', borderRadius: '5px', width: '85%', fontSize: '18px' }}
                                                                />
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>
                                                <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                                                    {
                                                        error &&
                                                        <Error
                                                            error={error}
                                                            onClose={errorCloses}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                    {
                                                        dialogRowData.courtOrderImg &&
                                                        <Grid item lg={2}>
                                                            <Grid container sx={{ backgroundColor: dialogRowData.courtOrderImgFlag ? getDocumentBackGroundColor(dialogRowData.courtOrderImgFlag) : getDocumentBackGroundColor(flag_courtOrderImg), borderRadius: "10px", minHeight: '125px', height: 'auto' }}>
                                                                <Grid item lg={12} className="tittlegrid" >
                                                                    <p className='docTitle'>Order Document</p>
                                                                </Grid>
                                                                <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                                                    <div onClick={() => { if (!courtOrderDocVerifyPopUp) { setCourtOrderDocVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                        {
                                                                            dialogRowData.courtOrderImg.slice(0, 6) === 'data:i' ? (
                                                                                flag_courtOrderImg === 1 ? (
                                                                                    <>
                                                                                        <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                        <img
                                                                                            src={tickicon}
                                                                                            width='25px'
                                                                                            height='25px'
                                                                                            alt="Tick Icon"
                                                                                            style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                                                        />
                                                                                    </>
                                                                                ) : flag_courtOrderImg === -1 ? (
                                                                                    <>
                                                                                        <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                        <img
                                                                                            src={crossIcon}
                                                                                            width='25px'
                                                                                            height='25px'
                                                                                            alt="Cross Icon"
                                                                                            style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                )
                                                                            ) : (
                                                                                <Base64Image data={pdfIcon} width='80' />
                                                                            )
                                                                        }
                                                                        {
                                                                            courtOrderDocVerifyPopUp &&
                                                                            <OpenBase64ImageInPopup
                                                                                docVerifyPopUp={courtOrderDocVerifyPopUp}
                                                                                hideDocVerifyPopup={hideCourtOrderDocVerifyAlert}
                                                                                documentName="Order Document"
                                                                                documentImage={dialogRowData.courtOrderImg}
                                                                                width={'100%'}
                                                                                document={dialogRowData.courtOrderImg}
                                                                                documentFlag={dialogRowData.courtOrderImgFlag}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                updateDocFlag={updateDocFlag}
                                                                                documentRemarks={courtOrderImgObjectionRemarks}
                                                                                titleToUpdateFlag="courtOrderImg"
                                                                                flag_document={flag_courtOrderImg}
                                                                                parentService={'courtOrder'}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </> :
                                            <>
                                                <h3 className='step-title'>{dialogRowData.applicationProgressId === 0 ? 'Final Action' : 'Final Action'}</h3>
                                                <div className='description-box'>
                                                    <p className='group-description'><InfoIcon className='icon' /> Application verification is in process by the Customer Service Lead.</p>
                                                </div>
                                            </>
                                        :
                                        ((dialogRowData.applicationProgressId === 0 && dialogRowData.objectionStatus === 1) || (dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1)) ?
                                            <>
                                                <h3 className='step-title'>Application Objection</h3>
                                                <Grid container spacing={2} className='field-survey-container'>
                                                    <Grid item lg={1.5}>
                                                        <Typography className='fieldLabel'>Order No.</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderNo ? dialogRowData.courtOrderNo : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    <Grid item lg={1.5}>
                                                        <Typography className='fieldLabel'>Order Date</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderDate ? convertDate(dialogRowData.courtOrderDate) : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4}>
                                                        <Typography className='fieldLabel'>Order Authority</Typography>
                                                        <TextField
                                                            value={dialogRowData.courtOrderBy ? dialogRowData.courtOrderBy : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                    {
                                                        !dialogRowData.deferredAmount &&
                                                        <Grid item lg={1.5} >
                                                            <Typography className='fieldLabel'>Set Aside Amount</Typography>
                                                            <TextField
                                                                value={dialogRowData.setAsideAmount ? numberFormatting(dialogRowData.setAsideAmount) : '-'}
                                                                fullWidth
                                                                disabled
                                                                name="iv_tariff_to_allot"
                                                                id="iv_tariff_to_allot"
                                                                className='fieldCoverageMarla'
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                                <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                                                    {
                                                        error &&
                                                        <Error
                                                            error={error}
                                                            onClose={errorCloses}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                    {
                                                        dialogRowData.courtOrderImg &&
                                                        <Grid item lg={2}>
                                                            <Grid container sx={{ backgroundColor: dialogRowData.courtOrderImgFlag ? getDocumentBackGroundColor(dialogRowData.courtOrderImgFlag) : getDocumentBackGroundColor(flag_courtOrderImg), borderRadius: "10px", minHeight: '125px', height: 'auto' }}>
                                                                <Grid item lg={12} className="tittlegrid" >
                                                                    <p className='docTitle'>Order Document</p>
                                                                </Grid>
                                                                <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                                                    <div onClick={() => { if (!courtOrderDocVerifyPopUp) { setCourtOrderDocVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                                        {
                                                                            dialogRowData.courtOrderImg.slice(0, 6) === 'data:i' ? (
                                                                                flag_courtOrderImg === 1 ? (
                                                                                    <>
                                                                                        <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                        <img
                                                                                            src={tickicon}
                                                                                            width='25px'
                                                                                            height='25px'
                                                                                            alt="Tick Icon"
                                                                                            style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                                                        />
                                                                                    </>
                                                                                ) : flag_courtOrderImg === -1 ? (
                                                                                    <>
                                                                                        <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                        <img
                                                                                            src={crossIcon}
                                                                                            width='25px'
                                                                                            height='25px'
                                                                                            alt="Cross Icon"
                                                                                            style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <Base64Image data={dialogRowData.courtOrderImg} width='80' height='100' />
                                                                                )
                                                                            ) : (
                                                                                <Base64Image data={pdfIcon} width='80' />
                                                                            )
                                                                        }
                                                                        {
                                                                            courtOrderDocVerifyPopUp &&
                                                                            <OpenBase64ImageInPopup
                                                                                docVerifyPopUp={courtOrderDocVerifyPopUp}
                                                                                hideDocVerifyPopup={hideCourtOrderDocVerifyAlert}
                                                                                documentName="Order Document"
                                                                                documentImage={dialogRowData.courtOrderImg}
                                                                                width={'100%'}
                                                                                document={dialogRowData.courtOrderImg}
                                                                                documentFlag={dialogRowData.courtOrderImgFlag}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                updateDocFlag={updateDocFlag}
                                                                                documentRemarks={courtOrderImgObjectionRemarks}
                                                                                titleToUpdateFlag="courtOrderImg"
                                                                                flag_document={flag_courtOrderImg}
                                                                                parentService={'courtOrder'}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                <Grid container spacing={2} className='field-survey-container'>
                                                    <Grid item lg={6}>
                                                        <Typography className='fieldLabel'>Reason</Typography>
                                                        <TextField
                                                            value={dialogRowData.remarks ? dialogRowData.remarks : '-'}
                                                            fullWidth
                                                            disabled
                                                            name="iv_tariff_to_allot"
                                                            id="iv_tariff_to_allot"
                                                            className='fieldCoverageMarla'
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </>
                                            :
                                            dialogRowData.applicationProgressId === 1 ?
                                                <>
                                                    <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                                        <h4 style={{ textAlign: 'center', width: '100%', marginTop: '0.5%' }} >Application Approved</h4>
                                                        <Button variant="outlined" onClick={() => { downloadBill(dialogRowData.refNo) }} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><DescriptionIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> Bill </Button>
                                                    </div>
                                                </> :
                                                null
                                    }
                                </div>
                                <div className="actions">
                                    {
                                        (dialogRowData.applicationProgressId === 0 && dialogRowData.objectionStatus === 0) &&
                                        <>
                                            <button className='view-button' onClick={callSetAsideApplicationApproval} >Approve</button>
                                            <button className='reject-button' style={{ float: 'right', marginRight: '10px' }} onClick={objectionpop}>
                                                Reject
                                            </button>
                                        </>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContentText >
                </DialogContent >
            </Dialog >

            < Dialog
                open={ApplicationsubmittedPopUp}
                onClose={() => { setApplicationSubmittedPopUp(false) }}
                fullWidth={true}
                maxWidth={'md'}
                className='subpopup-dialog' >
                <DialogTitle className='dialog-title'>
                    <p className='title'>
                        Application Submitted
                    </p>
                    <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
                </DialogTitle>
            </Dialog >

            {/* Objection Dialog */}
            < Dialog
                open={objectionPopUpOpen}
                onClose={hideObjectionPopup}
                fullWidth={true}
                maxWidth={'sm'}
                className='objectionDialog'
            >
                <DialogTitle className="objection-dialog-title" >
                    <Grid container className='objectionheadercontainer'>
                        <Grid item lg={11.75} className='applicationTitleGrid'>
                            <Typography variant='h5'>Reason for rejection</Typography>
                        </Grid>
                        <Grid item lg={0.25} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={hideObjectionPopup} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Grid container>
                            <Grid item lg={12}>
                                <Typography>Reason</Typography>
                                <TextField
                                    name="iv_objection_remarks"
                                    id='iv_objection_remarks'
                                    sx={{
                                        width: '100%',
                                        "& .MuiInputBase-input": {
                                            color: "black",
                                            padding: "3%",
                                            fontWeight: "bold",

                                        },
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: "5px", // Adds extra padding on top of sx styling
                                        },
                                    }}
                                    value={setAsideVerificationObjectionFormik.values.iv_objection_remarks}
                                    onChange={setAsideVerificationObjectionFormik.handleChange}
                                    onBlur={setAsideVerificationObjectionFormik.handleBlur}
                                />
                                <p style={{ color: 'red', fontSize: 'small' }}>
                                    {
                                        setAsideVerificationObjectionFormik.errors.iv_objection_remarks && setAsideVerificationObjectionFormik.touched.iv_objection_remarks ? (setAsideVerificationObjectionFormik.errors.iv_objection_remarks) : null
                                    }
                                </p>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="objection-dialog-action" >
                    <button onClick={setAsideVerificationObjectionFormik.handleSubmit} type='submit' className='submit-button'>Confirm</button>
                </DialogActions>
            </Dialog >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    )
});

export default SetAsideTable;